import {ElementSpec} from '@xh/hoist/core';
import {checkboxButton, CheckboxButtonProps} from '@xh/hoist/desktop/cmp/input';
import classNames from 'classnames';
import './WidgetToolbarButton.scss';

/** Boolean toggle for a widget toolbar, styled to match the toolbar's buttons. */
export function widgetToolbarCheckbox(props: ElementSpec<CheckboxButtonProps>): React.ReactElement<CheckboxButtonProps, any> {
    return checkboxButton({
        minimal: true,
        ...props,
        className: classNames('rzx-widget-toolbar-button', props.className)
    });
}
